(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-apply"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ca').forEach(function (wrap) {
    var gallery = wrap.querySelector('.ca-gallery-track');
    if (!gallery) return;
    wrap.querySelector('.ca-gallery-arrow--prev') && wrap.querySelector('.ca-gallery-arrow--prev').addEventListener('click', function () {
      var card = gallery.querySelector('.ca-gallery-card');
      gallery.scrollBy({ left: -((card ? card.offsetWidth : 200) + 12) * 3, behavior: 'smooth' });
    });
    wrap.querySelector('.ca-gallery-arrow--next') && wrap.querySelector('.ca-gallery-arrow--next').addEventListener('click', function () {
      var card = gallery.querySelector('.ca-gallery-card');
      gallery.scrollBy({ left: ((card ? card.offsetWidth : 200) + 12) * 3, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".trending-products-slider");
  const leftBtn = document.querySelector(".trending-arrow-left");
  const rightBtn = document.querySelector(".trending-arrow-right");

  if (container && leftBtn && rightBtn) {
    leftBtn.addEventListener("click", () => container.scrollBy({ left: -250, behavior: "smooth" }));
    rightBtn.addEventListener("click", () => container.scrollBy({ left: 250, behavior: "smooth" }));
  }
});

  } catch(e) { console.error(e); }
})();
})();
